import React, { useState } from 'react';
import { Box, Button, Container, Dialog, DialogContent, DialogTitle, Divider, IconButton, Link, Stack, Typography } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloseIcon from '@mui/icons-material/Close';
import MapIcon from '@mui/icons-material/Map';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import logo from '../../Assets/logo.png';

const WHATSAPP_NUMBER = '+201288339973';
const ADDRESS_TITLE = 'البحيرة - كفر الدوار';
const ADDRESS_DETAILS = 'شارع الحدايق - أمام أبراج الحلواني';
const MAPS_URL = 'https://maps.app.goo.gl/PuWNygHsKokaLx7B9';
const MAP_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d297.3632380165348!2d30.124207630902283!3d31.144196081930986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f5df543e407259%3A0xf79fac58009f305d!2sNuvvy!5e1!3m2!1sen!2seg!4v1788573187604!5m2!1sen!2seg';

const socialLinks = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/nuvvy.eg?igsh=ZXVmamVmMm16bzZ6&utm_source=qr',
    icon: <InstagramIcon sx={{ fontSize: 18 }} />,
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/share/18W4KAzweD/?mibextid=wwXIfr',
    icon: <FacebookIcon sx={{ fontSize: 18 }} />,
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@nuvvy.eg?_r=1&_t=ZT-94M8uD0Z3qX',
    icon: <MusicNoteIcon sx={{ fontSize: 18 }} />,
  },
];

const PublicFooter = () => {
  const normalizedWhatsapp = WHATSAPP_NUMBER.replace(/\D/g, '');
  const whatsappHref = `https://wa.me/${normalizedWhatsapp}`;
  const [openMap, setOpenMap] = useState(false);

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        borderTop: '1px solid rgba(252, 255, 222, 0.2)',
        background: 'linear-gradient(180deg, #173525 0%, #0f261a 100%)',
        color: '#fffff1',
        py: { xs: 3, md: 4.5 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
          spacing={2}
          sx={{ direction: 'rtl' }}
        >
          <Box sx={{ minWidth: { md: 250 } }}>
            <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 0.75 }}>
              <Box
                component="img"
                src={logo}
                alt="Nuvvy"
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: '8px',
                  objectFit: 'cover',
                  border: '1px solid rgba(252, 255, 222, 0.28)',
                  boxShadow: '0 12px 28px rgba(0, 0, 0, 0.18)',
                }}
              />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 900, lineHeight: 1.1 }}>
                  Nuvvy
                </Typography>
                <Typography variant="caption" sx={{ color: 'rgba(252, 255, 222, 0.75)' }}>
                  Smart Cafe Experience
                </Typography>
              </Box>
            </Stack>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 241, 0.78)', maxWidth: 330, lineHeight: 1.9 }}>
              تجربة كافيه ذكية تجمع المنيو، الطلب من الموبايل، وإنشاء مشروب مخصص بالذكاء الاصطناعي.
            </Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'flex-start', sm: 'center' }}>
            {socialLinks.map((item) => (
              <Link
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="inherit"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.75,
                  fontWeight: 800,
                  px: 1.25,
                  py: 0.7,
                  borderRadius: '999px',
                  backgroundColor: 'rgba(255, 255, 241, 0.08)',
                  border: '1px solid rgba(252, 255, 222, 0.16)',
                  color: '#fffff1',
                  transition: '0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(252, 255, 222, 0.14)',
                    borderColor: 'rgba(252, 255, 222, 0.35)',
                  },
                }}
              >
                {item.icon}
                {item.label}
              </Link>
            ))}
          </Stack>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'flex-start', sm: 'center' }}>
            <Box sx={{ minWidth: { md: 230 } }}>
              <Typography variant="body2" sx={{ mb: 0.5, color: 'rgba(252, 255, 222, 0.7)' }}>
                رقم واتساب
              </Typography>
              <Link
                href={whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                underline="none"
                color="inherit"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.75,
                  fontWeight: 900,
                  px: 1.25,
                  py: 0.75,
                  borderRadius: '999px',
                  backgroundColor: 'rgba(37, 211, 102, 0.1)',
                  border: '1px solid rgba(37, 211, 102, 0.28)',
                  color: '#fffff1',
                }}
              >
                <WhatsAppIcon sx={{ color: '#25D366', fontSize: 20 }} />
                {WHATSAPP_NUMBER}
              </Link>
            </Box>

            <Box sx={{ minWidth: { md: 280 } }}>
              <Typography variant="body2" sx={{ mb: 0.5, color: 'rgba(252, 255, 222, 0.7)' }}>
                العنوان
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: 1,
                  px: 1.25,
                  py: 0.75,
                  borderRadius: '8px',
                  backgroundColor: 'rgba(255, 255, 241, 0.08)',
                  border: '1px solid rgba(252, 255, 222, 0.16)',
                  color: '#fffff1',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75 }}>
                  <LocationOnIcon sx={{ color: '#d32f2f', fontSize: 20, mt: 0.25, flexShrink: 0 }} />
                  <Box>
                    <Typography variant="caption" sx={{ display: 'block', fontWeight: 800 }}>
                      {ADDRESS_TITLE}
                    </Typography>
                    <Typography variant="caption" sx={{ display: 'block', fontSize: '11px', color: 'rgba(255, 255, 241, 0.7)' }}>
                      {ADDRESS_DETAILS}
                    </Typography>
                  </Box>
                </Box>

                <Button
                  size="small"
                  variant="contained"
                  startIcon={<MapIcon />}
                  onClick={() => setOpenMap(true)}
                  sx={{
                    borderRadius: '999px',
                    fontWeight: 900,
                    color: '#173525',
                    background: 'linear-gradient(145deg, #fcffde 0%, #f7efbe 100%)',
                    boxShadow: 'none',
                    '&:hover': {
                      background: 'linear-gradient(145deg, #fffff1 0%, #fcffde 100%)',
                      boxShadow: '0 10px 24px rgba(0, 0, 0, 0.16)',
                    },
                  }}
                >
                  عرض العنوان على الخريطة
                </Button>
              </Box>
            </Box>
          </Stack>
        </Stack>

        <Divider sx={{ my: 2.5, borderColor: 'rgba(252, 255, 222, 0.12)' }} />

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          spacing={1}
          sx={{ direction: 'rtl', color: 'rgba(255, 255, 241, 0.68)' }}
        >
          <Typography variant="caption">© {new Date().getFullYear()}  Nuvvy  - جميع الحقوق محفوظة</Typography>
          <Stack direction="row" spacing={0.75} alignItems="center">
            <AutoAwesomeIcon sx={{ fontSize: 16, color: '#f7efbe' }} />
            <Typography variant="caption">أول تجربة AI Cafe مخصصة للعميل في مصر والشرق الأوسط</Typography>
          </Stack>
        </Stack>
      </Container>

      <Dialog
        open={openMap}
        onClose={() => setOpenMap(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            direction: 'rtl',
            borderRadius: '12px',
            overflow: 'hidden',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            fontWeight: 900,
            color: '#173525',
            borderBottom: '1px solid rgba(47, 87, 65, 0.12)',
          }}
        >
          موقع Nuvvy على الخريطة
          <IconButton onClick={() => setOpenMap(false)} aria-label="إغلاق">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: { xs: 1.5, sm: 2 }, backgroundColor: '#fffff1' }}>
          <Box
            component="iframe"
            title="Nuvvy location map"
            src={MAP_EMBED_URL}
            width="100%"
            height="430"
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            sx={{
              display: 'block',
              border: 0,
              borderRadius: '8px',
              minHeight: { xs: 320, sm: 430 },
              backgroundColor: '#ffffff',
            }}
          />
          <Button
            component={Link}
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            endIcon={<OpenInNewIcon />}
            sx={{
              mt: 2,
              borderRadius: '999px',
              fontWeight: 900,
              backgroundColor: '#173525',
              color: '#fffff1',
              '&:hover': { backgroundColor: '#244d35' },
            }}
          >
            فتح في Google Maps
          </Button>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default PublicFooter;
